// src/components/layout/navbar/Navbar.js
import React, { useState, useEffect } from 'react';
import './Navbar.css';
import mood2moveLogo from '../../../assets/images/logo512.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    scrollToElement(targetId);
  };

  const handleBrandClick = (e) => {
    e.preventDefault();
    scrollToTop();
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="nav-brand" onClick={handleBrandClick} style={{ cursor: 'pointer' }}>
        <img src={mood2moveLogo} alt="Mood2Move" className="logo" />
        <span className="brand-name">MOOD2MOVE</span>
      </div>

      <div className="nav-links">
        <a
          href="#features"
          className="nav-link"
          onClick={(e) => handleNavClick(e, 'features')}
        >
          
        </a>
        <a
          href="#about"
          className="nav-link"
          onClick={(e) => handleNavClick(e, 'about')}
        >
          About Us
        </a>
        <a
          href="#contact"
          className="nav-link"
          onClick={(e) => handleNavClick(e, 'contact')}
        >
          Contact Us
        </a>
      </div>

      <button
        className="nav-cta"
        onClick={scrollToTop}
      >
        Start Your Journey
      </button>
    </nav>
  );
};

export default Navbar;